import ClientService from "@/api/services/client.service";
import UserService from "@/api/services/user.service";
import CamerasService from "@/api/services/cameras.service";
import ModelsService from "@/api/services/models.service";
import TariffService from "@/api/services/tariff.service";
import ServersService from "@/api/services/servers.service";
import BillingService from "@/api/services/billing.service";
import logsService from "@/api/services/logs.service";
import IntercomsService from "@/api/services/intercoms.service";
import OrgService from "@/api/services/org.service";
import SipServersService from "@/api/services/sip_servers.service";
import OperatorService from "@/api/services/operator.service";
import SideTaskTypesService from "@/api/services/sideTaskTypes.service";
import PrioritiesService from "@/api/services/priorities.service";

export const ApiService = {
  client: ClientService,
  user: UserService,
  cameras: CamerasService,
  models: ModelsService,
  tariffs: TariffService,
  servers: ServersService,
  billing: BillingService,
  logs: logsService,
  sideTaskTypes: SideTaskTypesService,
  priorities: PrioritiesService,
  intercoms: IntercomsService,
  org: OrgService,
  sip_servers: SipServersService,
  operator: OperatorService
};
